import { useEffect, useRef, useState } from 'react';
import { STATUS_ORDER, STATUS_LABELS, NETWORKING_STATUS_ORDER, NETWORKING_STATUS_LABELS } from '@launchpad/shared';

const STATUS_COLORS = {
  saved: 'bg-status-saved',
  applied: 'bg-status-applied',
  interviewing: 'bg-status-interviewing',
  offer: 'bg-status-offer',
  rejected: 'bg-status-rejected',
  target: 'bg-slate-400',
  researched: 'bg-blue-400',
  outreach: 'bg-amber-400',
  scheduled: 'bg-emerald-400',
  nurturing: 'bg-purple-400',
};

export function StatusMenu({ currentStatus, position, onSelect, onClose, statusOrder, statusLabels }) {
  const order = statusOrder || STATUS_ORDER;
  const labels = statusLabels || STATUS_LABELS;
  const ref = useRef(null);
  const [adjusted, setAdjusted] = useState(position);

  useEffect(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    let { x, y } = position;
    if (y + rect.height > window.innerHeight) y = Math.max(4, position.y - rect.height);
    if (x + rect.width > window.innerWidth) x = Math.max(4, position.x - rect.width);
    setAdjusted({ x, y });
  }, [position]);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      style={{ top: adjusted.y, left: adjusted.x }}
      className="fixed z-[60] min-w-[140px] rounded-lg border border-slate-200 bg-white py-1 shadow-lg"
      role="menu"
    >
      {order.map((status) => (
        <button
          key={status}
          role="menuitem"
          disabled={status === currentStatus}
          onClick={() => onSelect(status)}
          className={`flex w-full items-center gap-2 px-3 py-1.5 text-sm text-left transition-colors ${
            status === currentStatus
              ? 'text-slate-400 cursor-default'
              : 'text-slate-700 hover:bg-slate-50'
          }`}
        >
          <span className={`size-2 rounded-full ${STATUS_COLORS[status] || 'bg-slate-300'}`} />
          {labels[status] || status}
        </button>
      ))}
    </div>
  );
}
